import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/landing/rv-community/banner-community.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service on_demand_banner lp-rv-community"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="rev-logo">
              <StaticImage
                src="../../../images/landing/rv-community/Revol-logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={212}
                height={50}
              />
            </div>

            <div className="banenr_content">
              <h1 style={{ marginBottom: "10px" }}>
                Empowering <span style={{ color: "#f47a14" }}>Startups </span>
                for Success
              </h1>
              <p>
                Uncover the ultimate launchpad for tech startups! Revol Ventures
                is dedicated to empowering entrepreneurs like you on your
                journey to success. Here, you'll find a wealth of resources, and
                meaningful connections, and receive unwavering support.
              </p>
            </div>
            <div className="tek-content">
              <span>Powered by</span>
              <StaticImage
                src="../../../images/landing/rv-community/Tek-logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={200}
                height={30}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="mt-auto offset-lg-1"
          >
            <div className="rev-main-img">
              <StaticImage
                src="../../../images/landing/rv-community/banner-girl.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={814}
                height={836}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
